import React from 'react';

import { flagStyles } from '../settings';

const SvgAU = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-264px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgAU;
